import { headerFontFamily } from "styles/theme";

const styles = {
  panel: {
    background: "linear-gradient(165deg, #eef0fe 0%, #e1e3fb 100%)",
    borderRadius: "26px",
    p: { xs: "24px 16px 26px", md: "36px 32px 38px" },
  },
  heading: {
    textAlign: "center",
    fontFamily: headerFontFamily,
    fontSize: "12px",
    letterSpacing: ".14em",
    textTransform: "uppercase",
    color: "#014339",
    mb: "22px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
    gap: "22px",
  },
};

export default styles;
